import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ClientBankAccountValidationService } from 'src/app/services/client-bank-account-validation.service';

@Component({
  selector: 'terra-swift-field',
  template: `
    <div class="terra-form-field-wrapper">
      <mat-icon class="notranslate" color="primary" matTooltipClass="terra-tooltip" matTooltipPosition="right" matTooltip="{{ tooltip }}">help</mat-icon>
      <label for="{{ inputId }}" class="text-input-label">SWIFT code</label>
      <mat-form-field appearance="outline">
        <input matInput [placeholder]="placeholder" class="uppercase-input lo_sensitive" [formControl]="control" [required]="requiredField" />
        <mat-hint align="start">{{ hint }}</mat-hint>
        <mat-hint align="end"
          ><i
            class="fa fa-info-circle fa-lg"
            matTooltipClass="terra-tooltip"
            matTooltipPosition="right"
            matTooltip="{{ tooltip }}"
            matTooltipPosition="before"
            matTooltipClass="terra-tooltip"
          ></i
        ></mat-hint>
        <mat-error *ngIf="control.hasError('required')">Required</mat-error>
        <mat-error *ngIf="control.hasError('pattern')">Please insert a SWIFT/BIC Code that matches the selected country</mat-error>
      </mat-form-field>
    </div>
  `
})
export class SwiftFieldComponent implements OnInit {
  @Input()
  public requiredField: boolean;
  @Input()
  public inputId: string;
  @Input()
  public placeholder: string;
  @Input()
  public control: UntypedFormControl;
  @Input()
  public hint: string;

  public tooltip =
    'SWIFT Code is a standard format of Bank Identifier Codes (BIC) and it is unique identification code for a particular bank. These codes are used when transferring money between banks, particularly for international wire transfers. The SWIFT consists of 8-11 digits both letters and numbers.';

  constructor(private validationService: ClientBankAccountValidationService) {}

  ngOnInit(): void {
    this.control.valueChanges
      .subscribe(val => {
        if (val !== null && val !== undefined && val.length > 0) {
          this.control.setErrors({ pattern: false });
          const validationResult = this.validationService.validateSwiftField(val);
          const validValue = this.control.value ? this.control.value.toUpperCase() : '';
          this.control.setValue(validValue, {emitEvent: false});
          if (
            validationResult !== null &&
            validationResult !== undefined &&
            validationResult.patterns !== null &&
            validationResult.patterns !== undefined &&
            validationResult.patterns.length > 0
          ) {
            this.control.setErrors({ pattern: true });
          } else {
            this.control.updateValueAndValidity({emitEvent: false});
          }
        } else {
          this.control.updateValueAndValidity({emitEvent: false});
        }
      });
  }
}
